export enum TaskType {
  TYPE_NOT_SET = 0,
  CONCEPTS_CLASSIFICATION = 1,
  BOUNDING_BOX_DETECTION = 2,
  POLYGON_DETECTION = 3,
}
export enum WorkerType {
  // for backward compatibility when task is not setting any type and only sets workers
  WORKER_TYPE_NOT_SET = 0,

  // only human workers
  WORKER_HUMAN = 1,

  // auto-annotation tasks. Task must set worker as model or workflow
  WORKER_AUTO = 2,
}

export enum TaskWorkerType {
  HUMAN = 'human',
  AI = 'ai',
}

export enum TaskWorkerStrategy {
  RESERVED = 1,
  WORKER_STRATEGY_NOT_SET = 0,
  PARTITIONED = 2,
  FULL = 3,
  DYNAMIC = 4,
}

export enum TaskPartitionedWorkerStrategy {
  WORKER_PARTITIONED_STRATEGY_NOT_SET = 0,
  EVENLY = 1,
}

export enum TaskReviewStrategy {
  TASK_REVIEW_STRATEGY_NOT_SET = 0,
  NONE = 1,
  MANUAL = 2,
  CONSENSUS = 3,
}

export enum TaskInputSourceType {
  INPUT_SOURCE_TYPE_NOT_SET = 0,
  ALL_INPUTS = 1,
  SAVED_SEARCH = 2,
  DATASET = 3,
}

export enum AnnotationDataType {
  NOT_SET = 0,
  TAG = 1,
  BOUNDING_BOX = 2,
  TAG_AND_BOUNDING_BOX = 3,
  POLYGON = 4,
  POINT = 8,
  SPAN = 16,
  MASK = 32,
}

export enum TaskPriority {
  TASK_PRIORITY_NOT_SET = 0,
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}
